//import Vue from 'vue'
import moment from 'moment'

import COMMON from '@/plugins/handsontable_common'
import BaseUpperSpacedCaseFormatter from '@/filters/BaseUpperSpacedCaseFormatter'

const _DATA = () => {
    function sourceCouriers() {
        return {
            'dhl': 'dhl',
            'shipper_maker': 'shipper_maker',
            'fedex': 'fedex',
            'ups': 'ups',
            'japanpost': '日本郵便',
            'ecms': 'ECMS',
            'orangeconnex': 'OrangeConnex',
        }
    }
    // SHIPPING_TABLE
    const DATA = {}
    DATA.METHODS = {
        data2JsonObject: (data) => {
            return data
                .map((v) => {
                    let data = {}
                    for (let i = 0; i < DATA.FIELDS_ALL.length; i++) {
                        data[DATA.FIELDS_ALL[i].name] = DATA.FIELDS_ALL[i].get(v[i], v)
                    }
                    return data
                })
        },
    }
    // SHIPPING_TABLE
    DATA.RENDERERS = {
        insurance: (instance, td, row, col, prop, value, cellProperties) => {
//            const obj = DATA.METHODS.data2JsonObject([ instance.getDataAtRow(row) ])[0]
        
            td.innerText = ''
            if (!value) {
                return td
            }
        
            const a = document.createElement('a')
            a.href = '/me/insurances/%23' + value
            a.target = '_blank'
            a.innerText = value
            td.appendChild(a)
            return td
        },
        shipping_tracking_codes: (instance, td, row, col, prop, value, cellProperties) => {
            const obj = DATA.METHODS.data2JsonObject([ instance.getDataAtRow(row) ])[0]
        
            td.innerText = ''

            if (!value || (typeof value !== 'string' && !Array.isArray(value))) {
                return td
            }

            let codes = []
            switch (typeof value) {
                case 'string':
                    codes.push(value)
                    break
                default:
                    if (Array.isArray(value)) {
                        codes = value
                    }
                    break
            }
        
            for (let i = 0; i < codes.length; i++) {
                const a = document.createElement('a')
                a.href = 'https://t.17track.net/ja#nums=' + codes[i].split("\n").join(',')
                let courier = obj.shipping_courier_plan.courier
                if (courier === 'shipper_maker') {
                    courier = obj.shipping_courier_plan.plan_name.split('_')[0]
                }
                switch (courier) {
                    case 'fedex':
                        a.href += '&fc=100003'
                        break
                    case 'ups':
                        a.href += '&fc=100002'
                        break
                    case 'dhl':
                        a.href += '&fc=100001'
                        break
                    case 'japanpost':
                        a.href += '&fc=10021'
                        break
                    case 'ecms':
                        a.href += '&fc=190168'
                        break
                    case 'orangeconnex':
                        a.href += '&fc=190205'
                        break
                }
                a.target = '_blank'
                a.innerText = codes[i]
                td.appendChild(a)
            }

            return td
        },
        shipping_courier_plan: (instance, td, row, col, prop, value, cellProperties) => {
            td.innerHTML = ''
            if (cellProperties.readOnly) {
                td.classList.add('htDimmed')
            }
            const a = document.createElement('a')
            a.href = 'javascript:void(0)'
            if (value) {
                let courier = BaseUpperSpacedCaseFormatter(value.courier)
                let plan_name = BaseUpperSpacedCaseFormatter(value.plan_name)

                a.classList.add('text-primary')
                a.innerHTML = `<div>[${courier}] ${plan_name}</div><div class="text-right">&yen;${Number(value.plan_cost).toLocaleString()}</div>`
            } else {
                a.classList.add('text-danger')
                a.innerText = `---------- 未選択 ----------`
            }
            td.appendChild(a)
            return td
        },
        shipping_item_attributes: (instance, td, row, col, prop, value, cellProperties) => {
            td.innerHTML = ''
            if (cellProperties.readOnly) {
                td.classList.add('htDimmed')
            }
            const div = document.createElement('div')
            if (value) {
                div.innerHTML = value
                    .split("\n")
                    .map((v) => {
                        return window.$trans.labels[
                            'shippings.attributes.'
                            +
                            v.replace(/^is_/g, '')
                        ]
                    })
                    .join("\n")
        //        div.innerHTML = window.$trans.labels['shippings.attributes.' + 'food']
            } else {
                div.innerText = ''
            }
            td.appendChild(div)
            return td
        },
    }
    // SHIPPING_TABLE
    DATA.FIELDS = {
        // システム入力
        SYSTEM: [
            {
                name: 'id',
                get: (v, v_all) => { return v },
                load: (v) => { return v.id },
                colHeader: 'システム<br>Tuskey発送番号',
                column: {
                    type: 'text',
                },
                readOnly: true,
            },
            {
                name: 'created_at',
                get: (v, v_all) => { return v },
                load: (v) => { return v.created_at },
                colHeader: '作成日',
                column: {
                    renderer: COMMON().RENDERERS.YYYY_MM_DD,
                },
                readOnly: true,
            },
            {
                name: 'user_id',
                get: (v, v_all) => { return v },
                load: (v) => { return v.user_id },
                colHeader: 'ユーザーID',
                column: {
                    type: 'text',
                },
                readOnly: true,
            },
            {
                name: 'insurance',
                get: (v, v_all) => { return v },
                load: (v) => { return v.insurance ? v.insurance.id : '' },
                colHeader: 'Tuskey保険番号',
                column: {
                    type: 'text',
                    renderer: DATA.RENDERERS.insurance,
                },
                readOnly: true,
            },
//            {
//                name: 'status',
//                get: (v, v_all) => { return v },
//                load: (v) => { return v.status },
//                colHeader: '状態',
//                column: {
//                    type: 'text',
//                    renderer: COMMON().RENDERERS.status,
//                },
//                readOnly: true,
//            },
//            {
//                name: 'shipping_courier',
//                get: (v, v_all) => { return v },
//                load: (v) => { return v.shipping_courier },
//                colHeader: 'クーリエ',
//                column: {
//                    type: 'dropdown',
//                    source: sourceCouriers(),
//                },
//                readOnly: true,
//            },
//            {
//                name: 'shipping_tracking_log',
//                get: (v, v_all) => { return v },
//                load: (v) => { return v.shipping_tracking_log },
//                colHeader: '追跡情報',
//                column: {
//                    type: 'text',
//                    renderer: COMMON().RENDERERS.shipping_tracking_log,
//                },
//                readOnly: true,
//            },
//            {
//                name: 'shipping_tracking_confirmed_at',
//                get: (v, v_all) => { return v },
//                load: (v) => { return v.shipping_tracking_confirmed_at },
//                colHeader: '追跡有効確認日時',
//                column: {
//                    type: 'date',
//                    dateFormat: 'YYYY-MM-DD HH:mm',
//                    correctFormat: true,
//                },
//            },
        ],
        // 発送情報
        COURIER: [
//            {
//                name: 'shipping_date',
//                get: (v, v_all) => { return v },
//                load: (v) => { return v.shipping_date },
//                colHeader: '発送予定日<i class="required" />',
//                column: {
//                    type: 'date',
//                    dateFormat: 'YYYY-MM-DD',
//                    correctFormat: true,
//                },
//            },
            {
                name: 'shipping_courier_plan',
                get: (v, v_all) => { return v },
                load: (v) => { return v.courier.shipping_courier_plan },
                colHeader: '発送サービス名<i class="required" />',
                column: {
                    type: 'text',
                    className: 'text-right',
                    renderer: DATA.RENDERERS.shipping_courier_plan,
                },
                readOnly: true,
            },
            {
                name: 'shipping_tracking_codes',
                get: (v, v_all) => { return v },
                load: (v) => { return v.shipping_tracking_codes },
                colHeader: '追跡番号',
                column: {
                    type: 'text',
                    renderer: DATA.RENDERERS.shipping_tracking_codes,
                },
            },
        ],
        SYSTEM_UPDATED_AT: [
            {
                name: 'updated_at',
                get: (v, v_all) => { return v },
                load: (v) => { return v.updated_at },
                colHeader: 'updated_at',
                column: {
                    type: 'text',
                },
                readOnly: true,
            },
        ],
        // 登記
        PROFILE: [
        ],
        // 発送人
        FROM: [
            {
                name: 'from_representative',
                get: (v, v_all) => { return v },
                load: (v) => { return v.from_representative },
                colHeader: '発送人<br>氏名<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'from_company',
                get: (v, v_all) => { return v },
                load: (v) => { return v.from_company },
                colHeader: '会社名/屋号<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'from_line1',
                get: (v, v_all) => { return v },
                load: (v) => { return v.from_line1 },
                colHeader: 'Address Line1<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'from_line2',
                get: (v, v_all) => { return v },
                load: (v) => { return v.from_line2 },
                colHeader: 'Address Line2',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'from_city',
                get: (v, v_all) => { return v },
                load: (v) => { return v.from_city },
                colHeader: 'City<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'from_state',
                get: (v, v_all) => { return v },
                load: (v) => { return v.from_state },
                colHeader: 'State Or Region<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'from_zip',
                get: (v, v_all) => { return v },
                load: (v) => { return v.from_zip },
                colHeader: 'Postal Code<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'from_country',
                get: (v, v_all) => { return v },
                load: (v) => { return v.from_country },
                colHeader: 'Country<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'from_tel',
                get: (v, v_all) => { return v },
                load: (v) => { return v.from_tel },
                colHeader: '電話<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'from_email',
                get: (v, v_all) => { return v },
                load: (v) => { return v.from_email },
                colHeader: 'メール<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'from_tax_id',
                get: (v, v_all) => { return v },
                load: (v) => { return v.from_tax_id },
                colHeader: 'TAX ID',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'from_vat_id',
                get: (v, v_all) => { return v },
                load: (v) => { return v.from_vat_id },
                colHeader: 'VAT ID',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'from_eori',
                get: (v, v_all) => { return v },
                load: (v) => { return v.from_eori },
                colHeader: 'EORI',
                column: {
                    type: 'text',
                },
            },
        ],
        // 受取人
        TO: [
            {
                name: 'to_representative',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_representative },
                colHeader: '受取人<br>担当者名<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'to_company',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_company },
                colHeader: '会社名/屋号',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'to_line1',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_line1 },
                colHeader: 'Address Line1<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'to_line2',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_line2 },
                colHeader: 'Address Line2',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'to_city',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_city },
                colHeader: 'City<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'to_state',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_state },
                colHeader: 'State Or Region<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'to_zip',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_zip },
                colHeader: 'Postal Code<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'to_country',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_country },
                colHeader: 'Country<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'to_tel',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_tel },
                colHeader: '電話<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'to_email',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_email },
                colHeader: 'メール',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'to_tax_id',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_tax_id },
                colHeader: 'TAX ID',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'to_vat_id',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_vat_id },
                colHeader: 'VAT ID',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'to_eori',
                get: (v, v_all) => { return v },
                load: (v) => { return v.to_eori },
                colHeader: 'EORI',
                column: {
                    type: 'text',
                },
            },
        ],
        // 輸入者
        IMPORTER: [
            {
                name: 'importer_representative',
                get: (v, v_all) => { return v },
                load: (v) => { return v.importer_representative },
                colHeader: '輸入者<br>担当者名<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'importer_company',
                get: (v, v_all) => { return v },
                load: (v) => { return v.importer_company },
                colHeader: '会社名/屋号<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'importer_line1',
                get: (v, v_all) => { return v },
                load: (v) => { return v.importer_line1 },
                colHeader: 'Address Line1<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'importer_line2',
                get: (v, v_all) => { return v },
                load: (v) => { return v.importer_line2 },
                colHeader: 'Address Line2',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'importer_city',
                get: (v, v_all) => { return v },
                load: (v) => { return v.importer_city },
                colHeader: 'City<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'importer_state',
                get: (v, v_all) => { return v },
                load: (v) => { return v.importer_state },
                colHeader: 'State Or Region<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'importer_zip',
                get: (v, v_all) => { return v },
                load: (v) => { return v.importer_zip },
                colHeader: 'Postal Code<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'importer_country',
                get: (v, v_all) => { return v },
                load: (v) => { return v.importer_country },
                colHeader: 'Country<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'importer_tel',
                get: (v, v_all) => { return v },
                load: (v) => { return v.importer_tel },
                colHeader: '電話<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'importer_email',
                get: (v, v_all) => { return v },
                load: (v) => { return v.importer_email },
                colHeader: 'メール',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'importer_tax_id',
                get: (v, v_all) => { return v },
                load: (v) => { return v.importer_tax_id },
                colHeader: 'TAX ID',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'importer_vat_id',
                get: (v, v_all) => { return v },
                load: (v) => { return v.importer_vat_id },
                colHeader: 'VAT ID',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'importer_eori',
                get: (v, v_all) => { return v },
                load: (v) => { return v.importer_eori },
                colHeader: 'EORI',
                column: {
                    type: 'text',
                },
            },
        ],
        // 発送情報
        SHIPPING: [
            {
                name: 'shipping_invoice_id',
                get: (v, v_all) => { return v },
                load: (v) => { return (v.invoice || {}).number },
                colHeader: '発送情報<br>Invoice番号<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'shipping_tax_target',
                get: (v, v_all) => { return v },
                load: (v) => { return (v.vat || {}).shipping_tax_target },
                colHeader: 'VAT対象',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'shipping_tax_vat',
                get: (v, v_all) => { return v },
                load: (v) => { return (v.vat || {}).shipping_tax_vat },
                colHeader: 'VAT登録番号',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'shipping_tax_vat_issuer',
                get: (v, v_all) => { return v },
                load: (v) => { return ((v.vat || {}).shipping_tax_name || '').split('___').pop() },
                colHeader: 'VAT登録番号発行国',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'shipping_item_quantity',
                get: (v, v_all) => { return v },
                load: (v) => { return (v.items || []).map(e => e.quantity).join("\n") },
                colHeader: '数量<i class="required" />',
                column: {
                    type: 'text',
                    className: 'text-right',
                    renderer: COMMON().RENDERERS.numeric,
                },
            },
            {
                name: 'shipping_item_hs_code',
                get: (v, v_all) => { return v },
                load: (v) => { return (v.items || []).map(e => e.hs_code).join("\n") },
                colHeader: 'HS Code<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'shipping_item_country',
                get: (v, v_all) => { return v },
                load: (v) => { return (v.items || []).map(e => e.country).join("\n") },
                colHeader: '原産国<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'shipping_item_name',
                get: (v, v_all) => { return v },
                load: (v) => { return (v.items || []).map(e => e.product).join("\n") },
                colHeader: '申告商品名（en）<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'item_currency',
                get: (v, v_all) => { return v },
                load: (v) => { return v.item_currency },
                colHeader: '通貨<i class="required" />',
                column: {
                    type: 'text',
                },
            },
            {
                name: 'shipping_item_price',
                get: (v, v_all) => { return v },
                load: (v) => { return (v.items || []).map(e => e.price).join("\n") },
                colHeader: '単価<i class="required" />',
                column: {
                    type: 'text',
                    className: 'text-right',
                    renderer: COMMON().RENDERERS.numeric,
                },
            },
//            {
//                name: 'shipping_item_price_total',
//                get: (v, v_all) => { return v },
//                load: (v) => { return v.shipping_item_price_total },
//                colHeader: '申告金額＝保険金額(JPY)<i class="required" />',
//                column: {
//                    type: 'numeric',
////                    numericFormat: {
////                        pattern: '0,0',
////                    },
//                    renderer: COMMON().RENDERERS.numeric,
//                    className: 'text-right',
//                },
//                readOnly: true,
//            },
            {
                name: 'shipping_box_depth',
                get: (v, v_all) => { return v },
                load: (v) => { return (v.boxes || []).map(e => e.depth).join("\n") },
                colHeader: '縦cm<i class="required" />',
                column: {
                    type: 'text',
                    className: 'text-right',
                    renderer: COMMON().RENDERERS.numeric,
                },
            },
            {
                name: 'shipping_box_width',
                get: (v, v_all) => { return v },
                load: (v) => { return (v.boxes || []).map(e => e.width).join("\n") },
                colHeader: '横cm<i class="required" />',
                column: {
                    type: 'text',
                    className: 'text-right',
                    renderer: COMMON().RENDERERS.numeric,
                },
            },
            {
                name: 'shipping_box_height',
                get: (v, v_all) => { return v },
                load: (v) => { return (v.boxes || []).map(e => e.height).join("\n") },
                colHeader: '高さcm<i class="required" />',
                column: {
                    type: 'text',
                    className: 'text-right',
                    renderer: COMMON().RENDERERS.numeric,
                },
            },
            {
                name: 'shipping_box_weight',
                get: (v, v_all) => { return v },
                load: (v) => { return (v.boxes || []).map(e => e.weight).join("\n") },
                colHeader: '重量kg<i class="required" />',
                column: {
                    type: 'text',
                    className: 'text-right',
                    renderer: COMMON().RENDERERS.numeric,
                },
            },
//            {
//                name: 'shipping_box_dimensional_weight',
//                get: (v, v_all) => { return v },
//                load: (v) => { return (v.boxes || []).map(e => e.dimensional_weight).join("\n") },
//                colHeader: '容積重量kg<i class="required" />',
//                column: {
//                    type: 'text',
//                    className: 'text-right',
//                    renderer: COMMON().RENDERERS.numeric,
//                },
//                readOnly: true,
//            },
//            {
//                name: 'shipping_item_attributes',
//                get: (v, v_all) => { return v },
//                load: (v) => { return v.shipping_item_attributes },
//                colHeader: '通関書類チェック',
//                column: {
//                    type: 'text',
//                    className: 'text-right',
//                    renderer: 'shipping_item_attributes',
//                },
//                readOnly: true,
//            },
        ],
    }
    DATA.FIELDS_ALL =
        DATA.FIELDS.SYSTEM
        .concat(DATA.FIELDS.COURIER)
        .concat(DATA.FIELDS.SYSTEM_UPDATED_AT)
        .concat(DATA.FIELDS.PROFILE)
        .concat(DATA.FIELDS.FROM)
        .concat(DATA.FIELDS.TO)
        .concat(DATA.FIELDS.IMPORTER)
        .concat(DATA.FIELDS.SHIPPING)
    return DATA
}

export default _DATA

